// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────
   ReturnsCreation — component styles
   ───────────────────────────────────────────── */

/* ── Page shell ── */
.rd-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 72px);
  overflow: hidden;
  background: radial-gradient(circle at top right, rgba(42, 113, 255, 0.1), transparent 28%),
    linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
  color: #0f172a;
  font-family: "DM Sans", sans-serif;
  margin-top: 70px;
}

.rd-scroll-area {
  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-bottom: 146px;
}

/* Custom vertical scrollbar */
.rd-scroll-area::-webkit-scrollbar {
  width: 8px;
}

.rd-scroll-area::-webkit-scrollbar-track {
  background: transparent;
}

.rd-scroll-area::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 10px;
}

.rd-scroll-area::-webkit-scrollbar-thumb:hover {
  background-color: #94a3b8;
}

/* ── Sticky header ── */
.rd-sticky-header {
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid rgba(255, 255, 255, 0.7);
  background: linear-gradient(180deg, rgba(248, 250, 252, 0.96) 0%, rgba(248, 250, 252, 0.88) 100%);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

.rd-header-inner {
  max-width: 1480px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
}

.rd-back-btn {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #475569;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}

.rd-back-btn:hover {
  background: #f1f5f9;
}

.rd-header-title-group {
  flex: 1;
  min-width: 0;
}

.rd-header-title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.rd-header-title {
  font-size: 24px;
  font-weight: 700;
  color: #020617;
  margin: 0;
}

.rd-order-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #2a71ff;
}

/* ── Body ── */
.rd-body {
  max-width: 1480px;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ── Context card ── */
.rd-context-card {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  padding: 16px 20px;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.06);
}

.rd-context-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 8px;
}

.rd-context-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 16px;
  font-size: 14px;
  color: #475569;
}

.rd-context-meta-name {
  font-weight: 600;
  color: #020617;
}

.rd-context-meta-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rd-manager-badge {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  border-radius: 9999px;
  border: 1px solid #d1fae5;
  background: rgba(236, 253, 245, 0.8);
  padding: 10px 16px;
  font-size: 14px;
  color: #064e3b;
}

.rd-manager-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #059669;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}

.rd-manager-name {
  font-weight: 600;
  font-size: 14px;
}

.rd-manager-role {
  font-size: 10px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #059669;
  margin: 0;
}

/* ── Item table card ── */
.rd-table-card {
  border-radius: 30px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.rd-table-card-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #f1f5f9;
  padding: 20px;
}

.rd-table-sub-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 4px;
}

.rd-table-title {
  font-size: 20px;
  font-weight: 700;
  color: #020617;
  margin: 0;
}

.rd-return-all-toggle {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #334155;
  cursor: pointer;
  user-select: none;
  transition: background 0.15s;
}

.rd-return-all-toggle:hover {
  background: #f1f5f9;
}

.rd-table-wrap {
  overflow-x: auto;
  position: relative;
}

/* ── Scoped table reset (.return-details-table-wrapper) ──
   Targets only the table inside this component to undo any
   inherited global table styles. Avoids all:unset so that
   display, box-model and browser semantics are preserved.   */
.return-details-table-wrapper table {
  width: 100%;
  min-width: 980px;
  border-collapse: collapse;
  text-align: left;
  table-layout: auto;
  border: none;
}

.return-details-table-wrapper thead,
.return-details-table-wrapper tbody {
  border: none;
}

.return-details-table-wrapper tr {
  border-top: 1px solid #f1f5f9;
  /* undo any row background set by a global rule */
  background-color: transparent;
}

/* prevent global :hover rules from overriding row colours */
.return-details-table-wrapper tr:hover {
  background-color: inherit;
}

.return-details-table-wrapper th,
.return-details-table-wrapper td {
  padding: 14px 20px;
  vertical-align: middle;
  border: none;
}

.return-details-table-wrapper th {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #94a3b8;
  background: rgba(248, 250, 252, 0.8);
  white-space: wrap;
}

.return-details-table-wrapper td {
  font-size: 14px;
}

/* ── Spinner override — hide browser number-input arrows ── */
.return-details-table-wrapper input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.return-details-table-wrapper input[type="number"]::-webkit-inner-spin-button,
.return-details-table-wrapper input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* ── Table cells ── */
.rd-cell-product-name {
  font-weight: 600;
  color: #0f172a;
  max-width: 120px;
  overflow: hidden;
  white-space: wrap;
  text-overflow: ellipsis;
}

.rd-cell-small {
  font-size: 14px;
  color: #64748b;
}

.rd-cell-price {
  font-weight: 500;
  color: #334155;
}

.rd-cell-qty {
  font-weight: 600;
  color: #0f172a;
}

/* ── Row highlight ── */
.rd-table-row--selected {
  background: rgba(42, 113, 255, 0.04);
}

.rd-table-row--default {
  background: #fff;
}

/* ── Qty control ── */
.rd-qty-control {
  display: inline-flex;
  align-items: center;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.rd-qty-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.15s;
  flex-shrink: 0;
}

.rd-qty-btn--active {
  color: #64748b;
}

.rd-qty-btn--disabled {
  color: #cbd5e1;
}

.rd-qty-input {
  width: 64px;
  height: 40px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  background: transparent;
  border: none;
  border-left: 1px solid #e2e8f0;
  border-right: 1px solid #e2e8f0;
  outline: none;
}

.rd-qty-input--active {
  color: #0f172a;
}

.rd-qty-input--disabled {
  color: #94a3b8;
}

/* ── Bottom action bar ── */
.rd-action-bar {
  position: fixed;
  bottom: 74px;
  left: 0;
  right: 0;
  z-index: 30;
  padding: 0 16px;
}

.rd-action-bar-inner {
  max-width: 1480px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-radius: 24px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background: #020617;
  padding: 16px 20px;
  color: #fff;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.28);
}

.rd-summary-min-width {
  min-width: 0;
}

.rd-summary-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.rd-summary-subtitle {
  font-size: 14px;
  color: #cbd5e1;
  margin-top: 4px;
}

.rd-proceed-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  border-radius: 18px;
  background: #2a71ff;
  border: none;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  padding: 0 24px;
  cursor: pointer;
  box-shadow: 0 14px 30px rgba(42, 113, 255, 0.28);
  transition: background 0.15s;
  white-space: nowrap;
  flex-shrink: 0;
}

.rd-proceed-btn:hover:not(:disabled) {
  background: #1a5fe0;
}

.rd-proceed-btn:disabled,
.rd-proceed-btn--disabled {
  background: #334155;
  color: #94a3b8;
  cursor: not-allowed;
  box-shadow: none;
}

/* ── Right drawer ── */
.rd-drawer-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.4);
  z-index: 1299;
}

.rd-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 24px 0 0 24px;
  box-shadow: -32px 0 120px rgba(15, 23, 42, 0.15);
  z-index: 1300;
  overflow: hidden;
}

.rd-drawer-header {
  position: relative;
  flex-shrink: 0;
  padding: 24px;
  background: #fff;
}

.rd-drawer-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  line-height: 1.3;
}

.rd-close-btn {
  position: absolute;
  right: 24px;
  top: 24px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #64748b;
  transition:
    border-color 0.15s,
    color 0.15s;
}

.rd-close-btn:hover {
  border-color: #cbd5e1;
  color: #0f172a;
}

.rd-drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 0 24px 32px;
}

/* ── Summary card (rows in a rounded card with dividers) ── */
.rd-summary-card {
  border-radius: 16px;
  border: 1px solid #f1f5f9;
  background: #fff;
  padding: 0 20px;
  overflow: hidden;
}

.rd-summary-divider {
  height: 1px;
  background: #f1f5f9;
  margin: 0;
}

.rd-detail-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  font-size: 14px;
}

.rd-detail-label {
  font-weight: 500;
  color: #64748b;
}

.rd-detail-value {
  font-weight: 700;
  color: #0f172a;
}

/* ── Payment section ── */
.rd-payment-section {
  margin-top: 24px;
}

.rd-section-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #64748b;
  margin: 22px 0 12px;
}

.rd-payment-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.rd-payment-btn {
  height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #94a3b8;
  cursor: pointer;
  transition:
    border-color 0.15s,
    color 0.15s;
}

.rd-payment-btn:hover:not(:disabled):not(.rd-payment-btn--selected) {
  border-color: #cbd5e1;
  color: #64748b;
}

.rd-payment-btn--selected {
  border: 2px solid #2a71ff;
  background: rgba(42, 113, 255, 0.03);
  color: #2a71ff;
}

.rd-payment-btn--disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.rd-payment-label {
  font-size: 13px;
  font-weight: 500;
  color: inherit;
}

.rd-payment-label--active {
  font-size: 13px;
  font-weight: 600;
  color: #2a71ff;
}

/* ── Amount box ── */
.rd-amount-box {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0 20px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  margin-bottom: 32px;
}

.rd-amount-box > span:first-child {
  color: black;
  font-weight: 700;
  font-size: 20px;
}

.rd-amount-value {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
}

.rd-amount-via {
  font-size: 14px;
  font-weight: 500;
  color: #94a3b8;
}

/* ── Confirm section ── */
.rd-confirm-section {
  margin-top: 32px;
}

.rd-confirm-btn {
  width: 100%;
  height: 52px;
  border-radius: 12px;
  background: #2a71ff;
  border: none;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(42, 113, 255, 0.24);
  transition: background 0.15s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.rd-confirm-btn:hover:not(:disabled) {
  background: #1f63ea;
}

.rd-confirm-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.rd-btn-loader {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid #fff;
  border-radius: 50%;
  display: inline-block;
  animation: rd-spin 0.8s linear infinite;
}

@keyframes rd-spin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/Returns/components/ReturnsCreation.css"],"names":[],"mappings":"AAAA;;kDAEkD;;AAElD,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB;qDACmD;EACnD,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,iDAAiD;EACjD,iGAAiG;EACjG,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;8DAG8D;AAC9D;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,iDAAiD;EACjD,6BAA6B;AAC/B;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gDAAgD;EAChD,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,gDAAgD;EAChD,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd;;eAEa;AACf;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf;;eAEa;AACf;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+CAA+C;EAC/C,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* ─────────────────────────────────────────────\n   ReturnsCreation — component styles\n   ───────────────────────────────────────────── */\n\n/* ── Page shell ── */\n.rd-page {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: calc(100vh - 72px);\n  overflow: hidden;\n  background: radial-gradient(circle at top right, rgba(42, 113, 255, 0.1), transparent 28%),\n    linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);\n  color: #0f172a;\n  font-family: \"DM Sans\", sans-serif;\n  margin-top: 70px;\n}\n\n.rd-scroll-area {\n  flex: 1;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  padding-bottom: 146px;\n}\n\n/* Custom vertical scrollbar */\n.rd-scroll-area::-webkit-scrollbar {\n  width: 8px;\n}\n\n.rd-scroll-area::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.rd-scroll-area::-webkit-scrollbar-thumb {\n  background-color: #cbd5e1;\n  border-radius: 10px;\n}\n\n.rd-scroll-area::-webkit-scrollbar-thumb:hover {\n  background-color: #94a3b8;\n}\n\n/* ── Sticky header ── */\n.rd-sticky-header {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.7);\n  background: linear-gradient(180deg, rgba(248, 250, 252, 0.96) 0%, rgba(248, 250, 252, 0.88) 100%);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n}\n\n.rd-header-inner {\n  max-width: 1480px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 20px;\n}\n\n.rd-back-btn {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #475569;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s;\n}\n\n.rd-back-btn:hover {\n  background: #f1f5f9;\n}\n\n.rd-header-title-group {\n  flex: 1;\n  min-width: 0;\n}\n\n.rd-header-title-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n.rd-header-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #020617;\n  margin: 0;\n}\n\n.rd-order-badge {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 9999px;\n  border: 1px solid #bfdbfe;\n  background: #eff6ff;\n  padding: 4px 12px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #2a71ff;\n}\n\n/* ── Body ── */\n.rd-body {\n  max-width: 1480px;\n  margin: 0 auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ── Context card ── */\n.rd-context-card {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.88);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  padding: 16px 20px;\n  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.06);\n}\n\n.rd-context-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  margin-bottom: 8px;\n}\n\n.rd-context-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px 16px;\n  font-size: 14px;\n  color: #475569;\n}\n\n.rd-context-meta-name {\n  font-weight: 600;\n  color: #020617;\n}\n\n.rd-context-meta-overflow {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rd-manager-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  border-radius: 9999px;\n  border: 1px solid #d1fae5;\n  background: rgba(236, 253, 245, 0.8);\n  padding: 10px 16px;\n  font-size: 14px;\n  color: #064e3b;\n}\n\n.rd-manager-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #059669;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  flex-shrink: 0;\n}\n\n.rd-manager-name {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.rd-manager-role {\n  font-size: 10px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #059669;\n  margin: 0;\n}\n\n/* ── Item table card ── */\n.rd-table-card {\n  border-radius: 30px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);\n  overflow: hidden;\n}\n\n.rd-table-card-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  border-bottom: 1px solid #f1f5f9;\n  padding: 20px;\n}\n\n.rd-table-sub-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  margin-bottom: 4px;\n}\n\n.rd-table-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #020617;\n  margin: 0;\n}\n\n.rd-return-all-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  border-radius: 9999px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #334155;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.15s;\n}\n\n.rd-return-all-toggle:hover {\n  background: #f1f5f9;\n}\n\n.rd-table-wrap {\n  overflow-x: auto;\n  position: relative;\n}\n\n/* ── Scoped table reset (.return-details-table-wrapper) ──\n   Targets only the table inside this component to undo any\n   inherited global table styles. Avoids all:unset so that\n   display, box-model and browser semantics are preserved.   */\n.return-details-table-wrapper table {\n  width: 100%;\n  min-width: 980px;\n  border-collapse: collapse;\n  text-align: left;\n  table-layout: auto;\n  border: none;\n}\n\n.return-details-table-wrapper thead,\n.return-details-table-wrapper tbody {\n  border: none;\n}\n\n.return-details-table-wrapper tr {\n  border-top: 1px solid #f1f5f9;\n  /* undo any row background set by a global rule */\n  background-color: transparent;\n}\n\n/* prevent global :hover rules from overriding row colours */\n.return-details-table-wrapper tr:hover {\n  background-color: inherit;\n}\n\n.return-details-table-wrapper th,\n.return-details-table-wrapper td {\n  padding: 14px 20px;\n  vertical-align: middle;\n  border: none;\n}\n\n.return-details-table-wrapper th {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  background: rgba(248, 250, 252, 0.8);\n  white-space: wrap;\n}\n\n.return-details-table-wrapper td {\n  font-size: 14px;\n}\n\n/* ── Spinner override — hide browser number-input arrows ── */\n.return-details-table-wrapper input[type=\"number\"] {\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n.return-details-table-wrapper input[type=\"number\"]::-webkit-inner-spin-button,\n.return-details-table-wrapper input[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* ── Table cells ── */\n.rd-cell-product-name {\n  font-weight: 600;\n  color: #0f172a;\n  max-width: 120px;\n  overflow: hidden;\n  white-space: wrap;\n  text-overflow: ellipsis;\n}\n\n.rd-cell-small {\n  font-size: 14px;\n  color: #64748b;\n}\n\n.rd-cell-price {\n  font-weight: 500;\n  color: #334155;\n}\n\n.rd-cell-qty {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n/* ── Row highlight ── */\n.rd-table-row--selected {\n  background: rgba(42, 113, 255, 0.04);\n}\n\n.rd-table-row--default {\n  background: #fff;\n}\n\n/* ── Qty control ── */\n.rd-qty-control {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n.rd-qty-btn {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: color 0.15s;\n  flex-shrink: 0;\n}\n\n.rd-qty-btn--active {\n  color: #64748b;\n}\n\n.rd-qty-btn--disabled {\n  color: #cbd5e1;\n}\n\n.rd-qty-input {\n  width: 64px;\n  height: 40px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 600;\n  background: transparent;\n  border: none;\n  border-left: 1px solid #e2e8f0;\n  border-right: 1px solid #e2e8f0;\n  outline: none;\n}\n\n.rd-qty-input--active {\n  color: #0f172a;\n}\n\n.rd-qty-input--disabled {\n  color: #94a3b8;\n}\n\n/* ── Bottom action bar ── */\n.rd-action-bar {\n  position: fixed;\n  bottom: 74px;\n  left: 0;\n  right: 0;\n  z-index: 30;\n  padding: 0 16px;\n}\n\n.rd-action-bar-inner {\n  max-width: 1480px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  border-radius: 24px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background: #020617;\n  padding: 16px 20px;\n  color: #fff;\n  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.28);\n}\n\n.rd-summary-min-width {\n  min-width: 0;\n}\n\n.rd-summary-title {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.rd-summary-subtitle {\n  font-size: 14px;\n  color: #cbd5e1;\n  margin-top: 4px;\n}\n\n.rd-proceed-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 48px;\n  border-radius: 18px;\n  background: #2a71ff;\n  border: none;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 0 24px;\n  cursor: pointer;\n  box-shadow: 0 14px 30px rgba(42, 113, 255, 0.28);\n  transition: background 0.15s;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.rd-proceed-btn:hover:not(:disabled) {\n  background: #1a5fe0;\n}\n\n.rd-proceed-btn:disabled,\n.rd-proceed-btn--disabled {\n  background: #334155;\n  color: #94a3b8;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n/* ── Right drawer ── */\n.rd-drawer-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.4);\n  z-index: 1299;\n}\n\n.rd-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  max-width: 480px;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 24px 0 0 24px;\n  box-shadow: -32px 0 120px rgba(15, 23, 42, 0.15);\n  z-index: 1300;\n  overflow: hidden;\n}\n\n.rd-drawer-header {\n  position: relative;\n  flex-shrink: 0;\n  padding: 24px;\n  background: #fff;\n}\n\n.rd-drawer-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n  line-height: 1.3;\n}\n\n.rd-close-btn {\n  position: absolute;\n  right: 24px;\n  top: 24px;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #64748b;\n  transition:\n    border-color 0.15s,\n    color 0.15s;\n}\n\n.rd-close-btn:hover {\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n.rd-drawer-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 24px 32px;\n}\n\n/* ── Summary card (rows in a rounded card with dividers) ── */\n.rd-summary-card {\n  border-radius: 16px;\n  border: 1px solid #f1f5f9;\n  background: #fff;\n  padding: 0 20px;\n  overflow: hidden;\n}\n\n.rd-summary-divider {\n  height: 1px;\n  background: #f1f5f9;\n  margin: 0;\n}\n\n.rd-detail-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 0;\n  font-size: 14px;\n}\n\n.rd-detail-label {\n  font-weight: 500;\n  color: #64748b;\n}\n\n.rd-detail-value {\n  font-weight: 700;\n  color: #0f172a;\n}\n\n/* ── Payment section ── */\n.rd-payment-section {\n  margin-top: 24px;\n}\n\n.rd-section-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #64748b;\n  margin: 22px 0 12px;\n}\n\n.rd-payment-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n.rd-payment-btn {\n  height: 80px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #94a3b8;\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    color 0.15s;\n}\n\n.rd-payment-btn:hover:not(:disabled):not(.rd-payment-btn--selected) {\n  border-color: #cbd5e1;\n  color: #64748b;\n}\n\n.rd-payment-btn--selected {\n  border: 2px solid #2a71ff;\n  background: rgba(42, 113, 255, 0.03);\n  color: #2a71ff;\n}\n\n.rd-payment-btn--disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.rd-payment-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: inherit;\n}\n\n.rd-payment-label--active {\n  font-size: 13px;\n  font-weight: 600;\n  color: #2a71ff;\n}\n\n/* ── Amount box ── */\n.rd-amount-box {\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0 20px;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  margin-bottom: 32px;\n}\n\n.rd-amount-box > span:first-child {\n  color: black;\n  font-weight: 700;\n  font-size: 20px;\n}\n\n.rd-amount-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.rd-amount-via {\n  font-size: 14px;\n  font-weight: 500;\n  color: #94a3b8;\n}\n\n/* ── Confirm section ── */\n.rd-confirm-section {\n  margin-top: 32px;\n}\n\n.rd-confirm-btn {\n  width: 100%;\n  height: 52px;\n  border-radius: 12px;\n  background: #2a71ff;\n  border: none;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 8px 24px rgba(42, 113, 255, 0.24);\n  transition: background 0.15s;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.rd-confirm-btn:hover:not(:disabled) {\n  background: #1f63ea;\n}\n\n.rd-confirm-btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.rd-btn-loader {\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid #fff;\n  border-radius: 50%;\n  display: inline-block;\n  animation: rd-spin 0.8s linear infinite;\n}\n\n@keyframes rd-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
